import { type BillingContact } from '../../../../types/BillingContact';
import { type ShippingContact } from '../../../../types/Shipping';
import { splitToFirstAndLastName } from '../../../../utils/splitToFirstAndLastName';

export const getUnifiedBillingContact = ({
  email,
  billing,
}: {
  email?: string;
  billing: google.payments.api.Address;
}): BillingContact => {
  return {
    email,
    ...splitToFirstAndLastName(billing.name),
    countryCode: billing.countryCode?.toUpperCase(),
    phone: billing.phoneNumber,
    postalCode: billing.postalCode,
    state: billing.administrativeArea,
    city: billing.locality,
  };
};

export const getUnifiedShippingContact = (shipping: google.payments.api.Address): ShippingContact => {
  return {
    ...splitToFirstAndLastName(shipping.name),
    countryCode: shipping.countryCode?.toUpperCase(),
    phone: shipping.phoneNumber,
    postalCode: shipping.postalCode,
    state: shipping.administrativeArea,
    city: shipping.locality,
    addressLine1: shipping.address1,
    addressLine2: shipping.address2,
  };
};
